// Static project data. Projects aren't backed by the database in this
// module (only blogs and users are), so this lives client-side and is
// shared between the Home page preview and the full Projects page.
const projects = [
  {
    id: 1,
    title: "AI-Driven Blockchain Certificate Verification System",
    description:
      "Secure certificate platform integrating YOLO-based forgery detection, Solidity smart contracts for blockchain storage, and IPFS for decentralized file management. Flask backend with Web3.py integration.",
    tags: ["Flask", "Web3.py", "Solidity", "YOLOv8", "IPFS"],
    gradient: "linear-gradient(135deg,#667eea 0%,#764ba2 100%)",
    githubUrl: "https://github.com/ksr2005",
  },
  {
    id: 2,
    title: "Web Deployable CARLA Simulation",
    description:
      "Browser-based autonomous driving simulation environment fully controllable from anywhere in the world via internet.",
    tags: ["Python", "CARLA", "Flask", "WebSockets"],
    gradient: "linear-gradient(135deg,#f093fb 0%,#f5576c 100%)",
    githubUrl: "https://github.com/ksr2005",
  },
  {
    id: 3,
    title: "Autonomous Vehicle with Raspberry Pi 5",
    description:
      "4WD autonomous vehicle with global internet-based teleoperation via web interface, OpenCV lane following using Canny edge detection, and CNN-based steering through behavior cloning.",
    tags: ["Flask", "OpenCV", "TensorFlow Lite", "Raspberry Pi"],
    gradient: "linear-gradient(135deg,#4facfe 0%,#00f2fe 100%)",
    githubUrl: "https://github.com/ksr2005",
  },
  {
    id: 4,
    title: "AI-Powered Multi-Modal Content Redaction System",
    description:
      "Serverless content moderation combining YOLOv8 face detection and EasyOCR hate speech extraction, deployed on Hugging Face Spaces with Docker and NVIDIA GPU acceleration.",
    tags: ["Python", "YOLOv8", "EasyOCR", "Docker", "Hugging Face"],
    gradient: "linear-gradient(135deg,#43e97b 0%,#38f9d7 100%)",
    githubUrl: "https://github.com/ksr2005",
  },
  {
    id: 5,
    title: "To-Do App",
    description:
      "Full stack task management web application with complete CRUD operations, clean UI, and REST API backend.",
    tags: ["HTML", "CSS", "JavaScript", "Node.js", "Express"],
    gradient: "linear-gradient(135deg,#fa709a 0%,#fee140 100%)",
    githubUrl: "https://github.com/ksr2005",
  },
];

export default projects;
